import React, { Fragment } from 'react';
import { FaClone, FaEdit, FaEye, FaNewspaper, FaSearch } from 'react-icons/fa';
import { MdDelete } from 'react-icons/md';
import { Table } from 'reactstrap';
import { ArcaHttpClientPageDetails } from '../../../code/ArcaHttpClientPageDetails';
import { ArcaHttpSystem } from '../../../code/ArcaHttpSystem';
import { ArcaPageDetails } from '../../../code/Types/ArcaPageDetails';
import { ArcaComponent } from '../../pages/ArcaComponent';
import { ArcaLink } from '../Fields/ArcaLink';
import { InputField } from '../Fields/InputField';
import { StatusBar } from '../StatusBar';
import { PageDetailsPanel } from './PageDetailsPanel';
import { PageEditPanel } from './PageEditPanel';
import { ModalPopup } from '../ModalPopup';

export class PageEditorPanel extends ArcaComponent {

    constructor(props) {
        super(props);
        this.state = {
            searchResults: null,
            pageDetails: null,
            statusText: null,
            isError: false,
            viewDetails: false,
            editDetails: false,
            showConfirmDelete: false,
            searchString: 'e'
        };
    }

    async componentWillMount() {
        await this.getAllItems()
    }

    async getAllItems() {
        await ArcaHttpClientPageDetails.SearchAsync('e',
            ((data) => this.setState({ searchResults: data, isError: false, statusText: null })),
            (() => this.setState({ isError: false, statusText: 'No items match your search!', searchResults: null })),
            ((err) => this.setState({ isError: true, statusText: err, searchResults: null }))
        )
    }

    render() {
        let { searchResults, isError, statusText, pageDetails, viewDetails, editDetails, showConfirmDelete } = this.state

        return (
            <Fragment>
                <h1>Page details editor</h1>
                <p>Search for you item by entering 2 or more charactors which appear in the title, preamble or text. The first 10 matching items will be returned.</p>
                <InputField
                    fieldname='Search ..'
                    regularExpression='free'
                    warnText='Invalid search text format'
                    mandatory={false}
                    showHeader={false}
                    onUpdate={this.getGetDocumentsBySearch.bind(this)}
                    fieldValid={true} />

                {editDetails
                    ? null
                    : <ArcaLink icon={<FaEdit />} width='100%' text='New Page' onClick={this.NewItem.bind(this)} />}

                <StatusBar message={statusText} isError={isError} />

                {searchResults
                    ? <Fragment>
                        {!viewDetails && !editDetails
                            ? <Table className='table table-striped' aria-labelledby="tabelLabel">
                                <thead>
                                    <tr>
                                        <th>View</th>
                                        <th>Group</th>
                                        <th>Title</th>
                                        {!ArcaHttpSystem.IsSmartphone
                                            ? <th>Preamble</th>
                                            : null}
                                    </tr>
                                </thead>
                                <tbody>
                                    {searchResults.length === 20
                                        ? <tr>
                                            <td colSpan='4'><b>There may be more answers. You may need to modify the search</b></td>
                                        </tr> : null}
                                    {searchResults.map((p, k) =>
                                        <Fragment key={k}>
                                            <tr>
                                                <td><ArcaLink icon={<FaEye />} width='140px' height='45px' text='View' onClick={() => this.ViewItem(p)} /></td>
                                                <td>{p.GroupName}</td>
                                                <td>{p.Title}</td>

                                                {!ArcaHttpSystem.IsSmartphone
                                                    ? <td>{p.Preamble}</td>
                                                    : null}
                                            </tr>
                                        </Fragment>)}

                                </tbody>
                            </Table> : null}

                        {viewDetails && pageDetails
                            ? <Fragment>
                                <div className='centerText'>
                                    <ArcaLink icon={<FaSearch />} width='140px' text='Search' onClick={() => this.setState({ viewDetails: false, editDetails: false })} />
                                    <ArcaLink icon={<FaEdit />} width='140px' text='Edit' onClick={this.EditItem.bind(this, pageDetails)} />
                                    <ArcaLink icon={<FaClone />} width='140px' text='Clone' onClick={this.CloneItem.bind(this, pageDetails)} />
                                    <ArcaLink icon={<MdDelete />} width='140px' text='Delete' onClick={this.DeleteItem.bind(this, pageDetails.Id)} />
                                    <ArcaLink icon={<FaNewspaper />} width='160px' text='NewsLetter' onClick={this.NewsLetterItem.bind(this, pageDetails.Id)} />
                                    <div className="rounded px-3 px-sm-4 py-3 py-sm-5">
                                        <PageDetailsPanel details={pageDetails} />
                                    </div>

                                </div>
                            </Fragment>
                            : null}

                        {editDetails && pageDetails
                            ? <Fragment>
                                <ArcaLink
                                    icon={<FaSearch />}
                                    width='100%'
                                    text='Search again'
                                    onClick={() => this.setState({ viewDetails: false, editDetails: false })} />
                                <PageEditPanel
                                    details={pageDetails}
                                    onSaved={(dets) => {
                                        this.ViewItem(dets);
                                        this.setState({
                                            isError: false,
                                            statusText: `Page '${dets.Title}' has been saved `
                                        })
                                    }} />
                            </Fragment>
                            : null}

                    </Fragment>
                    : null}

                {showConfirmDelete
                    ? <ModalPopup
                        title='Please confirm deletion'
                        text={`You have selected to delete the page '${pageDetails.Title}'. Please confirm your choice.`}
                        onConfirm={() => { this.setState({ showConfirmDelete: false }); this.DeleteItemExecute(pageDetails.Id) }}
                        onCancel={() => this.setState({ showConfirmDelete: false })}
                    />
                    : null}

            </Fragment>);
    }

    async EditItem(pageDetails) {
        this.setState({ pageDetails, viewDetails: false, editDetails: true })
    }

    async CloneItem(pageDetails) {
        let clonedItem = pageDetails;
        clonedItem.Id = 0;
        this.setState({ pageDetails: clonedItem, viewDetails: false, editDetails: true })
    }

    async NewItem() {
        this.setState({ pageDetails: new ArcaPageDetails(), viewDetails: false, editDetails: true })
    }

    async DeleteItem(id) {
        this.setState({ showConfirmDelete: true })
    }

    async DeleteItemExecute(id) {
        ArcaHttpClientPageDetails.DeleteAsync(
            id,
            (() => {
                this.setState({
                    viewDetails: false,
                    editDetails: false,
                    isError: false,
                    statusText: 'Page was deleted!'
                });
                this.getGetDocumentsBySearch(this.state.searchString, true) ;
            }),
            (() => this.setState({
                isError: true,
                statusText: 'Page not found on server!'
            })),
            ((msg) => this.setState({
                isError: true,
                statusText: msg
            }))
        )
    }

    async NewsLetterItem(pageId) {
        await ArcaHttpClientPageDetails.SendNewsLetterAsync(pageId,
            (() => this.setState({ isError: false, statusText: 'Newsletter sent!' })),
            (err) => alert(err));
    }

    async ViewItem(pageDetails) {
        this.setState({
            pageDetails, viewDetails: true,
            editDetails: false
        })
    }

    async getGetDocumentsBySearch(searchString, valid) {

        if (valid && searchString.length < 3) {
            return;
        }

        await ArcaHttpClientPageDetails.SearchAsync(searchString,
            ((data) => this.setState({ searchResults: data, isError: false, statusText: null, searchString })),
            (() => this.setState({ isError: false, statusText: 'No items match your search!', searchResults: null })),
            ((err) => this.setState({ isError: true, statusText: err, searchResults: null }))
        )
    }
}